import * as React from 'react';
import { match } from "react-router-dom";
import * as ReactGA from 'react-ga';
import { MatchesService } from '../../../share/services/matches';
import { IMatchResponse, IMatch } from '../../../share/types/match';
import { toastr } from 'react-redux-toastr';
import MatchesCard from './components/MatchesCard';
import routes from 'src/modules/Routing/routes';
import './match.css'

export interface IMatchProps {
  match: match<{ caseId: string, childId: string, searchId: string, matchId: string }>;
  isLoading: (loading: boolean) => void;
  loading?: boolean;
  history: any;
  type?: "adhoc" | "biometrica" | "gmcngine";
  childId?: string;
  caseId?: string;
}

export interface IMatchState {
  biometrica?: boolean;
  deleting: boolean;
}

export class Match extends React.Component<IMatchProps, IMatchResponse & IMatchState> {
  constructor(props: IMatchProps) {
    super(props);
    this.state = {
      matches: [],
      caseInfo: {},
      childInfo: {},
      matchInfo: {},
      deleting: false
    }
  }

  public componentDidMount() {
    this.loadData()
  }

  public async loadData() {
    try {
      await this.getMatchData(this.props.type as string)();
    } catch (error) {
      toastr.error('Error', 'There was a problem loading the provider information');
    }
    if (this.props.isLoading) { this.props.isLoading(false) };
  }

  public getBiometricaMatchId() {
    return this.props.match.url.split('/').pop();
  }

  public getMatchData(type: string) {
    const providers = {
      gmcngine: async () => {
        const childId = this.props.childId || this.props.match.params.childId;
        const caseId = this.props.caseId || this.props.match.params.caseId;
        const { matchId } = this.props.match.params;
        const data = await MatchesService.get(caseId, childId);
        data.matches = this.orderFirstMatch(data.matches, matchId);
        this.setState(data);
      },
      adhoc: async () => {
        const { matchId, searchId } = this.props.match.params;
        const data = await MatchesService.getAdhoc(searchId);
        if(matchId) {
          return this.setState({ matches: this.orderFirstMatch(data, matchId) });
        }
        return this.setState({ matches: data });
      },
      biometrica: async () => {
        const matchId = this.getBiometricaMatchId();
        const data = await MatchesService.getBiometrica(matchId as string);
        if (!data) {
          toastr.error('Error', 'The provided match id does not exist in our records');
          this.redirect(routes.MATCHESVIEW);
        }
        this.setState({ matchInfo: data, biometrica: true });
      }
    };
    return providers[type];
  }

  public orderFirstMatch(matches: IMatch[], matchId: string) {
    const matchesList = matches.filter(matchData => matchData.matchId !== matchId);
    const firstMatch = matches.find(matchData => matchData.matchId === matchId);
    return [firstMatch as IMatch, ...matchesList];
  }

  public deleteMatch = (matchId: string) => async () => {
    try {
      this.setState({ deleting: true })
      await MatchesService.deleteMatchById(matchId);
      this.setState(state => ({
        caseInfo: { ...state.caseInfo },
        childInfo: { ...state.childInfo },
        matches: [...state.matches.filter(matchData => matchData.matchId !== matchId)]
      }));
      ReactGA.event({
        category: 'Match',
        action: 'Discard match',
        label: 'Matches management'
      });
      if (this.state.matches.length > 0) {
        this.setState({ deleting: false });
      } else {
        await this.wait(1000);
        this.props.history.replace('/rekognition/matches');
      }
    } catch (error) {
      this.setState({ deleting: false });
      toastr.error('There was a problem', 'The match could not be discard');
    }
  }

  public redirect = (path: string) => {
    this.props.history.push(path);
  }

  public wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  public render() {
    return (
      <MatchesCard
        {...this.state}
        {...this.props}
        deleteMatch={this.deleteMatch}
        deleting={this.state.deleting}
      />
    );
  }
}
export default Match;



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/Match.tsx